
<script>
export default {
    created() {
    },
    mounted() {
    },
    data() {
        return {
        };
    },
    methods: {
    },
    computed: {
    },
    components: {
    }
};
</script>
<template>
<div class="task">
    <router-view></router-view>
</div>
</template>
<style scoped lang="stylus">

</style>